<template>
  <div v-if="notFound" :class="componentClassName">
    <a-page-heading>トライアル情報管理 </a-page-heading>
    <m-section>
      <m-action-card id="settingsTrialTitle" :title="`トライアル情報 （${companyList.length}）`">
        <template #action>
          <a-button
            id="addUserAdminBtn"
            :inline="true"
            variant="fill"
            color="primary"
            size="small"
            :label="buttonLabel"
            @click="handleButton()"
          />
        </template>

        <m-data-table ref="dataTable" :empty-text="emptyText" :fit="true" :data="companyList">
          <a-data-table-column prop="companyID" :min-width="120" label="契約ID" align="left" :filterable="true">
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_companyID"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('companyID', 'asc')"
                :handle-sort-descending="() => handleSort('companyID', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            class="t-setting-trial-list__wrap"
            prop="companyName"
            :min-width="100"
            label="企業名"
            align="left"
            :filterable="true"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_companyName"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('companyName', 'asc')"
                :handle-sort-descending="() => handleSort('companyName', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column prop="adminName" :min-width="100" label="マスタ管理者名" align="left" :filterable="true">
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_adminName"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('adminName', 'asc')"
                :handle-sort-descending="() => handleSort('adminName', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            class="t-setting-trial-list__wrap"
            prop="adminEmail"
            :min-width="160"
            label="メールアドレス"
            align="left"
            :filterable="true"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_adminEmail"
                class="t-setting-trial-list__wrap"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('adminEmail', 'asc')"
                :handle-sort-descending="() => handleSort('adminEmail', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column prop="adminPhoneNumber" label="電話番号" align="left" :filterable="true">
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_adminPhoneNumber"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('adminPhoneNumber', 'asc')"
                :handle-sort-descending="() => handleSort('adminPhoneNumber', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            prop="targetService"
            :min-width="100"
            label="対象サービス"
            align="left"
            :filterable="true"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_targetService"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('targetService', 'asc')"
                :handle-sort-descending="() => handleSort('targetService', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            prop="startDate"
            :min-width="120"
            label="トライアル開始日"
            align="left"
            :filterable="true"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_startDate"
                variant="sort-time"
                :handle-sort-ascending="() => handleSort('startDate', 'asc')"
                :handle-sort-descending="() => handleSort('startDate', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column prop="closeDate" :min-width="100" label="廃止日" align="left" :filterable="true">
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_closeDate"
                variant="sort-time"
                :handle-sort-ascending="() => handleSort('closeDate', 'asc')"
                :handle-sort-descending="() => handleSort('closeDate', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            prop="contractStatusName"
            :min-width="100"
            label="ステータス"
            align="left"
            :filterable="true"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_contractStatusName"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('contractStatusName', 'asc')"
                :handle-sort-descending="() => handleSort('contractStatusName', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column type="action" :width="160" align="center" class="a-data-table-column--action">
            <template #default="scope">
              <a-button
                :id="'companyInfoEdit' + scope.index"
                variant="round"
                size="small"
                label="編集"
                color="grey"
                icon="edit"
                icon-color="black"
                :inline="true"
                @click="handleCompanyEdit(scope.row)"
              />
            </template>
          </a-data-table-column>
        </m-data-table>
      </m-action-card>
    </m-section>
  </div>

  <!-- Confirm, Error Modal -->
  <teleport to="body">
    <o-modal
      id="settingTrialList_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import MSection from '@/components/molecules/section';
import MDataTable from '@/components/molecules/data-table';
import ADataTableColumn from '@/components/atoms/data-table-column';
import OModal from '@/components/organisms/modal';
import * as Handlebars from 'handlebars';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { POINT } from '@/libs/constants';

export default {
  name: 't-setting-trial-list',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    AText,
    MDataTable,
    ADataTableColumn,
    OModal,
  },
  mixins: [customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
    authInfo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedCompanyID: '',
      companyList: [],
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      notFound: false,
      contractStatusList: {
        use: 'トライアル利用中',
        transiting: '移行期間',
        close: '廃止済',
      },
      buttonFlag: true,
      buttonLabel: '廃止済を表示する',
      emptyText: 'トライアル情報の検索中です',
      filterList: [],
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-trial-list');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  async created() {
    if (this.companyID !== POINT) {
      this.$router.push({ path: '/permission-denied' });
    }

    await this.handlerFetchCompanyData();
  },
  methods: {
    handlerFetchCompanyData: async function () {
      this.emptyText = 'トライアル情報の検索中です';
      this.companyList = [];
      await this.postRequest('/companymgmt/getinitdata')
        .then(e => {
          this.notFound = true;
          // トライアル対象を抽出
          for (const tCompany of e.data) {
            if (tCompany.companyID.match(/^tri/)) {
              if (this.buttonFlag && tCompany.trialStatus && tCompany.trialStatus === 'close') {
                continue;
              }
              this.companyList.push(tCompany);
            }
          }
          if (this.companyList.length === 0) {
            this.emptyText = 'トライアル情報がありません';
            return;
          }
          // 開通日(トライアル開始日)の降順にソート
          this.companyList.sort((fst, scnd) => {
            if (fst.startDate > scnd.startDate) {
              return -1;
            } else if (fst.startDate < scnd.startDate) {
              return 1;
            } else {
              return 0;
            }
          });
          for (let i = 0; i < this.companyList.length; i++) {
            this.companyList[i].adminName = this.companyList[i].adminName
              ? this.companyList[i].adminName.replace('_', ' ')
              : this.companyList[i].adminName;
            this.companyList[i].targetService = this.companyList[i].voicedxOnlyFlag
              ? 'トライアル COTOHA Voice DX Basic'
              : 'トライアル COTOHA Call Center';
            if (this.companyList[i].trialStatus !== '') {
              if (this.companyList[i].trialStatus in this.contractStatusList) {
                this.companyList[i].contractStatusName = this.contractStatusList[this.companyList[i].trialStatus];
              } else {
                this.companyList[i].contractStatusName = '';
              }
            } else {
              this.companyList[i].contractStatusName = '';
            }
          }
          this.filterList = this.companyList;
        })
        .catch(err => {
          if (err === 404) this.$router.push({ path: '/permission-denied' });
          this.notFound = false;
        });
    },
    handleButton() {
      this.buttonFlag = !this.buttonFlag;
      this.buttonLabel = this.buttonFlag ? '廃止済を表示する' : '廃止済を表示しない';
      this.handlerFetchCompanyData();
    },
    handleCompanyEdit(row) {
      this.$router.push({ path: '/trialedit', query: { companyID: row.companyID } });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message, selectedCompanyID) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      this.companyList = this.companyList.filter(function (v) {
        return v.companyID !== selectedCompanyID;
      });
    },
    getFilterColumnIndex(prop) {
      let columnIndex = -1;
      this.$refs.dataTable.columns.forEach((column, index) => {
        if (column.prop === prop) {
          columnIndex = index;
        }
      });
      return columnIndex;
    },
    handleFilterCancel(prop) {
      const columnIndex = this.getFilterColumnIndex(prop);
      if (columnIndex !== -1) {
        this.$refs.dataTable.$refs.tableHeader.hideFilter(columnIndex);
      }
    },
    handleSort(prop, dir) {
      //昇順
      if (dir === 'asc') {
        this.filterList.sort(function (a, b) {
          if (a[prop] < b[prop]) return -1;
          if (a[prop] > b[prop]) return 1;
          return 0;
        });
      }
      //降順
      if (dir === 'desc') {
        this.filterList.sort(function (a, b) {
          if (a[prop] > b[prop]) return -1;
          if (a[prop] < b[prop]) return 1;
          return 0;
        });
      }
      this.handleFilterCancel(prop);
    },
  },
};
</script>
